import { IPageParam } from "@/Common/api/types/pagination";

const PAGINATION_SIZE = 1000;
const INITIAL_PAGE_PARAM: IPageParam<string> = { after: "", first: PAGINATION_SIZE };
const EMPTY_RESULT = { edges: [], pageInfo: { hasNextPage: false, endCursor: "" } };

export { PAGINATION_SIZE, INITIAL_PAGE_PARAM, EMPTY_RESULT };
